import { render } from "./SvgIconsSprite.vue?vue&type=template&id=466d4d00"
import script from "./SvgIconsSprite.vue?vue&type=script&lang=js"
export * from "./SvgIconsSprite.vue?vue&type=script&lang=js"

import exportComponent from "/Users/intr0vert/Git/ai-startup/aibanner/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__